import { twMerge } from "tailwind-merge"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string
}

const Button: React.FC<ButtonProps> = ({ className, ...props }) => {
  return (
    <button
      className={twMerge(`min-h-14 flex flex-row items-center justify-center px-8 rounded-full`, className)}
      {...props}
    />
  )
}

export default Button
